// re.rejouis.fr — carte produit (liste : recherche, scan).
// Pas de montant ici (retiré le 2026-10-16) : le « jusqu'à X € » affiché dès la
// tuile décevait une fois l'état décrit. Le crédit s'affiche à l'étape d'état.
import { Thumb, Icons, PastilleBoost } from './ui.jsx';
import { boostPrio, finPrio } from '../lib/prio.js';

export default function CarteProduit({ produit, dansPanier, onChoisir }) {
  return (
    <div className="card" style={{ display: 'flex', alignItems: 'center', gap: 12, padding: 12 }}>
      <Thumb produit={produit} />
      <div style={{ flex: 1, minWidth: 96 }}>
        <div style={{ fontWeight: 700, fontSize: 13.5, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{produit.titre}</div>
        {/* Modèle recherché (Prio) : pastille seule, le montant barré/boosté vient à l'étape d'état */}
        <PastilleBoost boost={boostPrio(produit)} fin={finPrio(produit)} style={{ position: 'relative', margin: '3px 0 1px' }} />
        <div style={{ fontSize: 11.5, color: 'var(--stone)', margin: '1px 0 0', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {[produit.marque, produit.categorie].filter(Boolean).join(' · ')}
        </div>
        {produit.handle ? (
          <a href={`https://rejouis.fr/products/${produit.handle}`} target="_blank" rel="noopener noreferrer"
            style={{ display: 'inline-flex', alignItems: 'center', gap: 4, marginTop: 3, fontSize: 11, fontWeight: 600, color: 'var(--rouge)', textDecoration: 'none' }}>
            Voir la fiche <Icons.external size={11} sw={2} />
          </a>
        ) : null}
      </div>
      <button onClick={() => onChoisir(produit)} aria-label={dansPanier ? 'Déjà au panier' : 'Estimer'}
        style={{ width: 38, height: 38, borderRadius: 999, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: dansPanier ? 'var(--mint)' : 'var(--rouge)', color: dansPanier ? 'var(--noir)' : '#fff' }}>
        {dansPanier ? <Icons.check size={18} sw={2.2} /> : <Icons.chev size={18} sw={2.2} />}
      </button>
    </div>
  );
}
